"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Checkbox_1 = __importDefault(require("../Checkbox/Checkbox"));
var __1 = require("..");
/**
 * A convenient component for a checkbox
 */
exports.default = react_1.forwardRef(function CheckboxButton(_a, ref) {
    var label = _a.label, color = _a.color, labelPlacement = _a.labelPlacement, id = _a.id, disabled = _a.disabled, checked = _a.checked, value = _a.value, onChange = _a.onChange, checkboxClassName = _a.className;
    return (jsx_runtime_1.jsx(__1.FormControlLabel, { ref: ref, control: jsx_runtime_1.jsx(Checkbox_1.default, { checked: checked, onChange: function (event) {
                var _a = event.target, checkboxValue = _a.value, checkboxChecked = _a.checked;
                onChange === null || onChange === void 0 ? void 0 : onChange(checkboxValue, !!checkboxChecked, event);
            }, value: value, color: color, id: id, disabled: disabled, className: checkboxClassName }, void 0), label: label, labelPlacement: labelPlacement }, void 0));
});
//# sourceMappingURL=CheckboxButton.js.map